import { useState, useEffect } from "react";
import "../styles.css";
import CardItem from "./CardItem/cardItem";
import ImgOdontoPediatria from "../assets/services/odontopediatria.png";
import ImgEndodontia from "../assets/services/endodontia.png";
import ImgDentistica from "../assets/services/dentistica.png";
import Imgimplantodontia from "../assets/services/implantodontia.png";
import ImgOrtodontia from "../assets/services/ortodontia.png";
import ImgClinicaGeral from "../assets/services/clinicageral.png";
import ImgCirurgia from "../assets/services/cirurgia.png";
import ImgHarmonizacao from "../assets/services/harmonizacao.png";
import ImgProtese from "../assets/services/protese.png";
import Separator from "./Separator/separator";

const services = [
    { name: "Endodontia", description: "Tratamento de canal para preservar dentes comprometidos.", image: ImgEndodontia },
    { name: "Dentística", description: "Restauração estética e funcional dos dentes.", image: ImgDentistica },
    { name: "Odontopediatria", description: "Cuidado odontológico especializado para crianças.", image:ImgOdontoPediatria   },
    { name: "Implantodontia", description: "Colocação de implantes dentários para reposição de dentes.", image: Imgimplantodontia },
    { name: "Ortodontia", description: "Correção do alinhamento e posição dos dentes.", image: ImgOrtodontia },
    { name: "Clínica Geral", description: "Atendimento odontológico para prevenção e tratamento geral.", image: ImgClinicaGeral },
    { name: "Cirurgia Buco Maxilo Facial", description: "Procedimentos cirúrgicos para correções ósseas e faciais.", image: ImgCirurgia },
    { name: "Harmonização Orofacial", description: "Procedimentos estéticos para equilíbrio da face.", image: ImgHarmonizacao },
    { name: "Próteses", description: "Reabilitação oral com próteses fixas e removíveis para restauração da função e estética.", image: ImgProtese }
  ];
  
  export default function Services() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [visibleCards, setVisibleCards] = useState(3);
  
    useEffect(() => {
      const updateVisibleCards = () => {
        const width = window.innerWidth;
        if (width >= 1200) setVisibleCards(4);
        else if (width >= 992) setVisibleCards(3);
        else if (width >= 768) setVisibleCards(2);
        else setVisibleCards(1);
      };
  
      updateVisibleCards();
      window.addEventListener("resize", updateVisibleCards);
      return () => window.removeEventListener("resize", updateVisibleCards);
    }, []);
  
    const nextSlide = () => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % services.length);
    };
  
    const prevSlide = () => {
      setCurrentIndex((prevIndex) => (prevIndex - 1 + services.length) % services.length);
    };
  
    // Criar um array contínuo para looping
    const extendedServices = [...services, ...services];
    const displayedServices = extendedServices.slice(currentIndex, currentIndex + visibleCards);
  
    return (
      <section className="services-section" id="services">
        <div className="tit-sections">
          <h1>Nossos Serviços</h1>
          <Separator />
          <h2>"Compromisso com sua saúde bucal e bem-estar, oferecendo tratamentos de qualidade com tecnologia e cuidado personalizado."</h2>
        </div>

        <div className="services-carousel-container">
          <button className="carousel-btn" onClick={prevSlide}>&#10094;</button>
          <div className="services-carousel">
            {displayedServices.map((service, index) => (
              <CardItem key={index} color="cardItem" title={service.name} text={service.description} image={service.image} />
            ))}
          </div>
          <button className="carousel-btn" onClick={nextSlide}>&#10095;</button>
        </div>
        <div className="carousel-indicators">
          {services.map((_, index) => (
            <span
              key={index}
              className={`indicator ${index === currentIndex ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
            ></span>
          ))}
        </div>
        <div>
        <input type="button"   
          onClick={(e) => {
            e.preventDefault();
            window.open("https://wa.me/5511930693338?text=Oi!%20Gostaria%20de%20receber%20atendimento.", "_blank");
            // Rastreamento de conversão do Google Ads
            if (window.gtag) {
              window.gtag('event', 'conversion', {
                'send_to': 'AW-16944490858/aL4_CM-jl7MaEOrS4Y8_',
                'value': 1
              });
            }
        }} className="cta-button-transparent" value="Entre em contato agora" />
        </div>

      </section>
    );
  }
  